// extracted by mini-css-extract-plugin
module.exports = {"modal_wrapper":"Modal_modal_wrapper__10vE2"};